




























































































import AbpBase from "@/lib/abpbase";
import Util from "@/lib/util";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {
	GetDialysateJcList,
	InsertDialysateJc,
	UpdateDialysateJcById,
	DeleteDialysateJc, GetMachineListByWardOrChangJ
} from '../../../api/engineer'
import {GetPinYin, GetWuBi} from '../../../api/sys'

@Component
export default class Environment extends AbpBase {
	machines = []
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	columns = [
		{
			key: 'detectionDate',
			title: '时间',
			render:(h:any, p:any)=>{
				return h('span', this.formatDateTime(p.row.detectionDate))
			}
		},
		{
			key: 'machineID',
			title: '透析机'
		},
		{
			key: 'jskXj',
			title: '进水口细菌',
			render:(h:any, p:any)=>{
				return h('span',{
					style:{
						color: p.row.jskXj > 120 ? 'red' : ''
					}
				},p.row.jskXj + ' cfu/ml')
			}
		},
		{
			key: 'jskNds',
			title: '内毒素',
			render:(h:any, p:any)=>{
				return h('span',{
					style:{
						color: p.row.jskNds > 0.7 ? 'red' : ''
					}
				},p.row.jskNds + ' EU/ml')
			}
		},
		{
			key: 'cskXj',
			title: '出水口细菌',
			render:(h:any, p:any)=>{
				return h('span',{
					style:{
						color: p.row.cskXj > 120 ? 'red' : ''
					}
				},p.row.cskXj + ' cfu/ml')
			}
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	dateRangeChange(event:any){
		this.dateRange = event
		this.getData()
	}
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '120px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	util = Util
	dateRange:any = []
	status: any = ''

	created() {
		const end = new Date();
		const start = new Date();
		start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
		this.dateRange = [this.formatDate(start), this.formatDate(end)]
		this.getSelects()
		this.getData()
	}


	//获取拼音五笔
	async getCode(val: any) {
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.countryPY = res1
		this.dialogForm.countryWB = res2
	}
	formatDateTime(val: string) {
		if (val) {
			let arr = val.split('T')
			let arr1 = arr[1].split(':')
			return arr[0] + ' ' + arr1[0] + ':' + arr1[1]
		} else {
			return ''
		}
	}
	createCounty() {
		this.dialogTitle = '新增透析液检测'
		this.dialogForm = {detectionDate: (new Date() as any).Format('yyyy-MM-dd HH:mm')}
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let res = await GetDialysateJcList({
			QueryString: this.key,
			StDate: this.dateRange[0],
			EnDate: this.dateRange[1],
			Status: this.status,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑透析液检测'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}

	async del(row: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteDialysateJc({Id: row.id})
			this.getData()
		}).catch(() => {

		});

	}

	async confirm() {
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增透析液检测') {
					let res = await InsertDialysateJc(this.dialogForm)
				} else if (this.dialogTitle === '编辑透析液检测') {
					let res = await UpdateDialysateJcById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})
	}

	rules = {
		detectionDate: [{required: true, message: '请输入内容', trigger: 'blur'}],
		jcItem: [{required: true, message: '请输入内容', trigger: 'blur'}],
		jcResult: [{required: true, message: '请输入内容', trigger: 'blur'}],
		jskXj: [{required: true, message: '请输入内容', trigger: 'blur'}],
		jskNds: [{required: true, message: '请输入内容', trigger: 'blur'}],
		cskXj: [{required: true, message: '请输入内容', trigger: 'blur'}],
		machineID: [{required: true, message: '请选择透析机'}],
	}

	pageChange(val: any) {
		this.page = val
		this.getData()
	}

	private async getSelects() {
		let res = await GetMachineListByWardOrChangJ({SkipCount:1, MaxResultCount:10000})
		this.machines = res.items
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/engineer/dialysate/index.vue